import { Mail, MapPin, MessageCircle } from "lucide-react";
import { PageHero } from "./Katalog";
import { SocialLinks } from "../components/site/Footer";
import { useSettings, waLink } from "../lib/api";

const InfoRow = ({ icon: Icon, label, children }) => (
  <div className="flex gap-4">
    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[var(--gold-soft)] text-[var(--earth)]"><Icon className="h-5 w-5" /></span>
    <div>
      <p className="text-xs font-semibold uppercase tracking-wider text-[var(--ink)]/50">{label}</p>
      <div className="mt-1 text-[var(--ink)]">{children}</div>
    </div>
  </div>
);

export default function Kontak() {
  const { data: s } = useSettings();
  return (
    <>
      <PageHero eyebrow="Hubungi Kami" title="Kunjungi atau Hubungi Kami" desc="Tim kami siap membantu pertanyaan seputar pemesanan sapi, kunjungan kandang, dan konsultasi peternakan." />
      <section className="mx-auto grid max-w-7xl gap-10 px-5 py-14 lg:grid-cols-5 lg:px-8">
        <div className="space-y-7 lg:col-span-2">
          <a href={waLink(s?.whatsapp, "Halo Admin Sembada Satwa, saya ingin bertanya.")} target="_blank" rel="noreferrer" className="flex items-center gap-4 rounded-3xl bg-[#25D366] p-6 text-white transition-transform hover:-translate-y-1" data-testid="contact-whatsapp-btn">
            <MessageCircle className="h-10 w-10" />
            <div>
              <p className="text-lg font-semibold">Chat via WhatsApp</p>
              <p className="text-sm text-white/85">Langsung terhubung dengan admin kami</p>
            </div>
          </a>
          <InfoRow icon={MessageCircle} label="WhatsApp"><span data-testid="contact-whatsapp-number">+{s?.whatsapp}</span></InfoRow>
          <InfoRow icon={Mail} label="Email"><a href={`mailto:${s?.email}`} className="hover:text-[var(--forest)]" data-testid="contact-email">{s?.email}</a></InfoRow>
          <InfoRow icon={MapPin} label="Alamat"><span data-testid="contact-address">{s?.address}</span></InfoRow>
          <SocialLinks s={s} className="text-[var(--forest)]" />
        </div>
        <div className="overflow-hidden rounded-3xl border lg:col-span-3">
          {s?.maps_embed_url && (
            <iframe title="Lokasi Sembada Satwa" src={s.maps_embed_url} className="h-[420px] w-full lg:h-full lg:min-h-[480px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map" />
          )}
        </div>
      </section>
    </>
  );
}
